import { PublicationLeftMenuList } from "../utils/constants";
import EPurashreeBooks from "../data/EPurashreeBooks.json";
import { scrollContainerStyle } from "../components/TableStructure";
import { CommonPageUiLayer } from "../components/CommonPageUiLayer";

const E_Purashree = () => {
  return (
    <CommonPageUiLayer leftNavsList={PublicationLeftMenuList}>
      <div className="inner-title2">
        <h3 className="fontSizeClass">Publication</h3>
      </div>
      <div className="col-lg-12 about-head1">
        <div className="dig-login1 dig-form" style={{ padding: " 16px 0px" }}>
          <div className="inner-title3">
            <h3
              className="fontSizeClass mb-2"
              style={{
                display: "block",
                color: "white",
                fontWeight: "bold",
                backgroundColor: "#302ba0",
                padding: "10px 20px",
              }}
            >
              KMC Publications
            </h3>
          </div>

          <ol style={scrollContainerStyle}>
            {EPurashreeBooks.map(({ id, title, year, month, issue }) => (
              <li key={id}>
                <a
                  href={`/e-purashree/${year}/${month}/${issue}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="nav-link fontSizeClass"
                >
                   <i class="bi bi-book mr-2"></i> {title}
                </a>
              </li>
            ))}
          </ol>
        </div>
      </div>
    </CommonPageUiLayer>
  );
};

export default E_Purashree;
